import React, { useContext } from 'react';
import { OrderContext } from '../contexts/OrderContext'
import './Pagamento.css';

export default function Pagamento() {
  const order = useContext(OrderContext).order
  return (
    <section id="payment-informations">

      <div className='header-pay'>
        <h1>Total</h1>
        <h1>Pagamento</h1>
        <h1>Marketing</h1>
        <h1>Promoções</h1>
      </div>

      <div className='info-pay'>
        <div className='info-total'>
          <p><strong>Subtotal:</strong><small>{(order.totals[0].value / 100)}</small> </p>
          <p><strong>Desconto:</strong><small>{order.totals[1].value / 100}</small></p>
          <p><strong>Frete:</strong><small>{order.totals[2].value / 100}</small></p>
          <p><strong>Taxas:</strong><small>{order.totals[3].value / 100}</small></p>
          <p><strong>Total:</strong><small>{order.value / 100}</small></p>
        </div>

        <div className='info-total'>
          <p><strong>Pagamento:</strong><small>{order?.paymentData.transactions[0].payments[0].paymentSystemName}</small></p>
          <p><strong>Valor: </strong> <small>{order?.totals[0].value / 100}</small></p>
          <p><strong>Parcelas:</strong><small>{order?.paymentData.transactions[0].payments[0].installments}</small></p>
          <p><strong>TID:</strong><small>{order?.paymentData.transactions[0].payments[0].tid}</small></p>
          <p><strong>NSU: </strong><small>{order?.paymentData.transactions[0].payments[0].connectorResponses.nsu}</small></p>
        </div>

        <div className='info-total'>
          <p><strong>Marketing: </strong><small>{order?.marketingData?.marketingTags}</small></p>
        </div>

        <div className='info-total'>
          <p><strong>Promoções :</strong><small>{order.ratesAndBenefitsData.rateAndBenefitsIdentifiers.map(item => {
            return (
              <p>{item.name}</p>
            )
          })}</small></p>
        </div>
      </div>


    </section>

  )
}